const { removeCartFromLocalStorage } = require('../cart/localCart');
const { analyticsEventBus, ANALYTICS_EVENTS } = require('./events');
const {
  searchDataStorage,
  searchDataOfCartItemsStorage,
} = require('./stores/searchData');

/**
 * Add the needed handlers at the end of the handlers queue.
 * Nor mally useful for post-sending processing
 */
function addFinalHandlers() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.checkoutPurchaseConfirmed,
    () => {
      gaInfo.isPageView = false;
      removeCartFromLocalStorage();
      searchDataStorage.clear();
      searchDataOfCartItemsStorage.clear();
    }
  );
}

module.exports = {
  addFinalHandlers,
};
